import { enableProdMode } from '@angular/core';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
  console.assert = function () { };
  console.clear = function () { };
  console.count = function () { };
  console.countReset = function () { };
  console.debug = function () { };
  console.dir = function () { };
  console.dirxml = function () { };
  console.error = function () { };
  console.group = function () { };
  console.groupCollapsed = function () { };
  console.groupEnd = function () { };
  console.info = function () { };
  console.log = function () { };
  console.table = function () { };
  console.time = function () { };
  console.timeEnd = function () { };
  console.timeLog = function () { };
  console.timeStamp = function () { };
  console.trace = function () { };
  console.warn = function () { };
}
//test
bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);